import { formatWorkTime } from '../text';
import { IWorkTimeInfo } from '../../types/newbuilding';

export function getWorkTime(workTimeInfo?: IWorkTimeInfo | null) {
  return workTimeInfo
    ? `Режим работы с ${formatWorkTime(workTimeInfo.callFrom)} до ${formatWorkTime(workTimeInfo.callTo)}`
    : '';
}
